export default __webpack_public_path__ + "static/media/Background_00134.508e9bba.png";